import { TooltipData } from '../data/tooltip-data';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useAppSelector } from '@zonofi/zono-money-helpers';
import {
  getCurrentTooltipIndex,
  getIsTourActive,
} from '@zonofi/zono-money-store';

export const useTourController = () => {
  const [holdTourRun, setHoldTourRun] = useState<boolean>(false);
  const joyrideRef = useRef(null);

  const isTourActive = useAppSelector(getIsTourActive);
  const currentTooltipIndex = useAppSelector(getCurrentTooltipIndex);

  const steps = useMemo(() => {
    return [TooltipData()[currentTooltipIndex]];
  }, [currentTooltipIndex]);

  const checkDrawerReady = (target: string) => {
    return Boolean(document.querySelector(target));
  };

  const waitForElement = useCallback(
    (selector: string, maxRetries = 200): Promise<Element | null> => {
      return new Promise((resolve, reject) => {
        let retryCount = 0;
        const checkInterval = 100;

        const check = () => {
          const element = document.querySelector(selector);

          if (element) {
            resolve(element);
            return;
          }

          retryCount++;
          if (retryCount >= maxRetries) {
            reject('element not found');
            return;
          }

          setTimeout(check, checkInterval);
        };

        check();
      });
    },
    []
  );

  const selectors = useMemo(() => {
    return [TooltipData()[currentTooltipIndex]];
  }, [currentTooltipIndex]);

  useEffect(() => {
    if (!isTourActive) {
      return;
    }
    const selector = selectors?.[0]?.target;
    setHoldTourRun(true);
    waitForElement(selector as string).then((element) => {
      if (element) {
        setHoldTourRun(false);
      } else {
        console.log('Element not found');
        setHoldTourRun(false);
      }
    });
  }, [isTourActive, selectors, waitForElement]);

  return {
    currentTooltipIndex,
    checkDrawerReady,
    holdTourRun,
    isTourActive,
    joyrideRef,
    setHoldTourRun,
    steps,
  };
};
